export interface PublishGateInputs {
  hasPublishedVersion: boolean;
  isLoading: boolean;
  /** From useOfferHasPublishedVersion — true only when there is no known-good data yet. */
  isUnknownPublishStatus: boolean;
}

export interface PublishGateState {
  /** Disable the generate/preview affordance. */
  disabled: boolean;
  /** Show the "publish required" inline hint. */
  showHint: boolean;
}

/**
 * Derives the shared "publish required" gate for the client-share dialog's preview button
 * and the public-link controls' generate button from the useOfferHasPublishedVersion signal.
 * Centralizes the three-state logic (loading / known-not-published / unknown) so both
 * call sites can't silently diverge:
 *
 * - loading: disabled, no hint (optimistic disable while we don't know yet)
 * - known not published: disabled + hint
 * - unknown (no successful fetch yet): fail open, no hint (server-side error/toast handles it)
 * - has a published version: enabled, no hint
 */
export function derivePublishGateState({
  hasPublishedVersion,
  isLoading,
  isUnknownPublishStatus,
}: PublishGateInputs): PublishGateState {
  const disabled = isLoading || (!hasPublishedVersion && !isUnknownPublishStatus);
  const showHint = !isLoading && !hasPublishedVersion && !isUnknownPublishStatus;
  return { disabled, showHint };
}
